import Form from 'react-bootstrap/Form';
import React, { useState, useEffect } from 'react';
import { _eval } from "../utils";
import BaseField from './BaseField';

function CheckboxInput(props) {

    const [input, setInput] = useState([]);
    const [uid, setUid] = useState();

    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setUid(Date.now().toString(36) + Math.random().toString(36).substring(2))
    }, [])


    const handleChange = (v, s) => {
        let isChecked;

        // Check if we must map the field
        const map = (() => {
            if (_eval(props, 'data', 'map'))
                return props.data.map
            else
                return false
        })()

        // If value is set, use it
        if ('value' in props.data && props.data.value && s === true){
            s = props.data.value
        }
        setChecked(s != false)
        setInput(input) // ? is this needed ?

        // If value is an interest, merge/rm with existing interests
        if(v === 'INTERETS') {
            const interestVal = props.data.value;
            let currentVals = props.formData['INTERETS']?.value
                ? props.formData['INTERETS'].value.split('|').map(i => i.trim())
                : [];
            if(s)
                currentVals = currentVals.concat([interestVal])
            else
                currentVals = currentVals.filter(_v => _v !== interestVal)
            
            s = [...new Set(currentVals)].join(' | ') // rm duplicates and join
        }

        let validity = true
        if(props.data.required && !s) validity = false // if required and not checked, invalid
        props.handleChange(props.data.sid, { value: s, validity: validity, map: map })
    }

    return (
        <BaseField
            data={props.data}
            handleChange={props.handleChange}
            formData={props.formData}
        >

            <Form.Label>
            </Form.Label>

            <Form.Check
                type={'checkbox'}
                id={`checkbox-for-${props.data.sid}-${uid}`}
                feedback={props.data.helper}
                feedbackType="invalid"
            >
                <Form.Check.Input
data-validity-selector={props.data.sid}
                    checked={props.data.value == true ? true : checked}
                    required={props.data.required ? true : false}
                    type={'checkbox'}
                    onChange={e => { handleChange(props.data.sid, e.target.checked) }}
                />
                <Form.Check.Label>
                    {props.data.label}
                    {props.data.required ?
                        <sup className='text-danger'>&nbsp;*</sup>
                        : null}
                </Form.Check.Label>
            </Form.Check>

        </BaseField>
    );
}

export default CheckboxInput;